import axios from 'axios';
import router from '@/router'
import Cookies from 'js-cookie';

// 优先使用运行时注入的 BASE_API
const runtimeBaseApi = (typeof window !== 'undefined' && window.__APP_ENV__ && window.__APP_ENV__.BASE_API) ? window.__APP_ENV__.BASE_API : null
if (runtimeBaseApi) {
    axios.defaults.baseURL = runtimeBaseApi
} else {  //本地环境
    axios.defaults.baseURL = 'http://192.168.18.127:5000'
}

axios.interceptors.request.use(config => {   //对数据请求进行拦截
    if (config.url.match(/login/)) {   
        return config
    }
    if (Cookies.get("token")) {   //登录后添加验证签名
        config.headers['Authorization'] = Cookies.get("token");
    }
    return config
}, error => {
    return Promise.reject(error)
})

axios.interceptors.response.use(  //对数据回复进行拦截	
    response => {
        if (response.data.code == 403) {
            Cookies.remove("token")
            Cookies.remove("userInfo")
            router.push({
                path: '/login',
            });
            return response
        } else {
            return response
        }
    },
    error => {
        //  	alert("当前服务异常，请稍候再试！")
        return Promise.reject(error.data)
    }
)

export default axios;


// WEBPACK FOOTER //
// ./src/request/config.js